import segment from 'src/js/modules/analytics/segment';

const {
  trackers: { trackEvent },
  constants: { events },
} = segment;

const trackDesignMenuItemClick = (optionId) =>
  trackEvent(events.DESIGN_SETTINGS_OPTION_CLICKED, {
    optionId,
  });

export default trackDesignMenuItemClick;
